import { Env } from '@repo/types/config';

class EnvController {
    private currentEnv: Env = Env.Production;

    getCurrentEnv() {
        return this.currentEnv;
    }

    setCurrentEnv(value: Env) {
        this.currentEnv = value;
    }
}

export const envController = new EnvController();

export const getApiBasePath = (): string => {
    const env = envController.getCurrentEnv();

    if (env === Env.Test) {
        return 'https://backend.test.uxsignals.com';
    }
    if (env === Env.Staging) {
        return 'https://snap0.uxsignals-backend.uxsignals.iterate.iterapp.no';
    }
    if (env === Env.Localhost) {
        return 'http://localhost:4000';
    }
    return 'https://api.uxsignals.com';
};

export const getBasePath = (): string => {
    const env = envController.getCurrentEnv();
    if (env === Env.Test) {
        return 'https://widget.test.uxsignals.com';
    }
    if (env === Env.Localhost) {
        const localBasePath = 'http://localhost:8080';
        return localBasePath;
    }

    if (env === Env.Staging) {
        return 'https://snap0.uxsignals-frontend.uxsignals.iterate.iterapp.no';
    }
    return 'https://widget.uxsignals.com';
};

export function getDashboardPath(): string {
    const env = envController.getCurrentEnv();
    switch (env) {
        case Env.Localhost: {
            const localDashboardPath = 'http://localhost:3000';
            return localDashboardPath;
        }
        case Env.Test:
            return 'https://app.test.uxsignals.com';
        case Env.Staging:
            return 'https://snap0.uxsignals-dashboard.uxsignals.iterate.iterapp.no';
        default:
            return 'https://app.uxsignals.com';
    }
}
